import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import { CashFlowSection } from './CashFlowSection';
import { CashFlowCategorySection } from './CashFlowCategorySection';
import { CashFlowSectionMonthlySurplus } from './CashFlowSectionMonthlySurplus';

export const CashFlowSectionPicker = ({
  sectionResource,
  onEditItemClick,
}) => {
  // TODO: it would be nice to pick based on section type, but we'd need different section resources.
  if (sectionResource.attr('categories').resources().list().length > 0) {
    return (
      <CashFlowCategorySection
        sectionResource={sectionResource}
        onEditItemClick={onEditItemClick}
      />
    );
  }

  if (sectionResource.attr('sectionName') === 'monthlySurplus') {
    return (
      <CashFlowSectionMonthlySurplus
        sectionResource={sectionResource}
      />
    );
  }

  return (
    <CashFlowSection
      sectionResource={sectionResource}
      onEditItemClick={onEditItemClick}
    />
  );
};

CashFlowSectionPicker.defaultProps = {
  onEditItemClick: noop,
};

CashFlowSectionPicker.propTypes = {
  sectionResource: PropTypes.object.isRequired,
  onEditItemClick: PropTypes.func,
};
